import { CheckIcon } from "@/src/shared/assets/icons"

import { screenTexts } from "../localization/screen"

const flatIcon = "size-5 [&_path]:fill-current [&_path]:[fill-opacity:1]"

type MarkAllProps = {
  failed: boolean
  onMarkAll: () => void
}

export function MarkAll({ failed, onMarkAll }: MarkAllProps) {
  return (
    <div>
      <button
        type="button"
        className="inline-flex text-sm cursor-pointer items-center gap-2 text-purple-300"
        onClick={onMarkAll}
      >
        <CheckIcon aria-hidden className={flatIcon} />
        <span>{screenTexts.markAll}</span>
      </button>
      {failed ? (
        <p role="status" className="mt-1 text-sm text-white/75">
          {screenTexts.markAllFailed}
        </p>
      ) : null}
    </div>
  )
}
